import Img1 from "../images/download/appstore.svg";
import Img2 from "../images/download/googleapp.svg";

function Download() {
  return (
    <>
      <section className='download-section'>
        <div className='container'>
          <div className='download-text'>
            <h2>
              Access our platform for the best experience and exclusive
              features.
            </h2>
            <p>
              Thrown shy denote ten ladies though ask saw. Or by to he going
              think order event music. Incommode so intention defective at
              convinced. Led income months itself and houses you.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download;
